import { useState } from "react";
import { absoluteTime, formatTime } from "../data";
import ResourceTooltip from './ResourceTooltip';
import { Tooltip } from 'react-tooltip';
import { useDragContext } from './DragContext';

export const ProductionActionView = ({startTime, action, onMoveAction, onDeleteAction, onToggleDeactivate, last, changeSetProduction, showExtraWait}) => {
    // Determine if the action is deactivated
    const isDeactivated = action.deactivated === true;
    const [settings, setSettings] = useState(action.payload.settings);
    const [showTooltip, setShowTooltip] = useState(false);
    const { isDragging } = useDragContext();
    
    // Check if we have state data to show in tooltip
    const hasStateData = action.stateAfter || action.stateBefore;
    
    // Don't show tooltip when dragging
    const shouldShowTooltip = showTooltip && !isDragging && hasStateData;

    const handleChange = (e) => {
        const { name, value, checked } = e.target;
        setSettings((prev) => {
            // prev.startTime = new Date(value);
            if(name == "extra_wait")
              prev[name] = input_to_time(value);
            else
              prev[name] = value === 'on' ? checked : parseFloat(value) / 100.0;
            changeSetProduction(action.planetId, action.index, prev);
            return { ... prev };
        });
    }

    const time_to_input = (hours) => 
    {
      const totalSeconds = Math.floor(hours * 3600); // Convert hours to total seconds
      
      const days = Math.floor(totalSeconds / (24 * 3600));
      const remainingSecondsAfterDays = totalSeconds % (24 * 3600);
      
      const hrs = Math.floor(remainingSecondsAfterDays / 3600);
      const remainingSecondsAfterHours = remainingSecondsAfterDays % 3600;
      
      const mins = Math.floor(remainingSecondsAfterHours / 60);
      const secs = remainingSecondsAfterHours % 60;

      
      return `${hrs < 10 ? "0" + hrs : hrs}:${mins < 10 ? "0" + mins : mins}:${secs < 10 ? "0" + secs : secs}`;
    }

    const input_to_time = (value) =>
    {
      const parts = value.split(':');
      if(parts.length < 3)
        return 0;
      const hrs = parseInt(parts[0]);
      const min = parseInt(parts[1]);
      const sec = parseInt(parts[2]);
      return hrs + min / 60 + sec / 3600;
    }

    return (
        <li 
          key={action.index} 
          className={"col-span-1 m-0 p-1 rounded-sd shadow-sd flex justify-between items-start " + 
            (isDeactivated ? "bg-gray-600 opacity-70 " : action.valid ? "bg-gray-800" : "bg-red-400")}
          data-tooltip-id={`tooltip-${action.index}`}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
            <div className="w-2/3">
                {/* Action Summary */}
                <div className={"font-semibold text-left " + (isDeactivated ? "text-gray-400" : "text-gray-200")}>
                  {isDeactivated ? "[Deactivated] " : ""}Set Production
                </div>
                {/* Start Time and End Time */}
                <div className="text-sm text-gray-400 text-left">
                  Start: {absoluteTime(startTime, action.startTime)}
                </div>
                <div className="p-4 bg-gray-800 text-white rounded-lg shadow-md space-y-4">
                    {/* Row with Label and Checkboxes */}
                    <div className="flex items-center space-x-4">
                        <label className="text-gray-300 font-medium">Wait for:</label>
                        <div className="flex items-center space-x-4">
                            <input checked={settings.awaitResearch} onChange={handleChange} name="awaitResearch" type="checkbox" id="option1" className="form-checkbox text-blue-600 bg-gray-700 rounded focus:ring-0" />
                            <label htmlFor="option1" className="text-gray-300">Research</label>
                            <input checked={settings.awaitBuilding} onChange={handleChange} name="awaitBuilding" type="checkbox" id="option2" className="form-checkbox text-blue-600 bg-gray-700 rounded focus:ring-0" />
                            <label htmlFor="option2" className="text-gray-300">Buildings</label>
                            <input checked={settings.awaitHangar} onChange={handleChange} name="awaitHangar" type="checkbox" id="option3" className="form-checkbox text-blue-600 bg-gray-700 rounded focus:ring-0" />
                            <label htmlFor="option3" className="text-gray-300">Hangar</label>
                        </div>
                    </div>

                    {/* Row with Label and Select Inputs */}
                    <div className="flex items-center space-x-4">
                        <label className="text-gray-300 font-medium">M / C / D:</label>
                        <div className="flex items-center space-x-4">
                        <select value={settings.metalMine * 100} onChange={handleChange} name="metalMine" className="bg-gray-700 text-white p-1 rounded-md">
                            <option value="100">100%</option>
                            <option value="90">90%</option>
                            <option value="80">80%</option>
                            <option value="70">70%</option>
                            <option value="60">60%</option>
                            <option value="50">50%</option>
                            <option value="40">40%</option>
                            <option value="30">30%</option>
                            <option value="20">20%</option>
                            <option value="10">10%</option>
                            <option value="0">0%</option>
                        </select>
                        <select value={settings.crystalMine * 100} onChange={handleChange} name="crystalMine" className="bg-gray-700 text-white p-1 rounded-md">
                            <option value="100">100%</option>
                            <option value="90">90%</option>
                            <option value="80">80%</option>
                            <option value="70">70%</option>
                            <option value="60">60%</option>
                            <option value="50">50%</option>
                            <option value="40">40%</option>
                            <option value="30">30%</option>
                            <option value="20">20%</option>
                            <option value="10">10%</option>
                            <option value="0">0%</option>
                        </select>
                        <select value={settings.deuteriumSynthesizer * 100} onChange={handleChange} name="deuteriumSynthesizer" className="bg-gray-700 text-white p-1 rounded-md">
                            <option value="100">100%</option>
                            <option value="90">90%</option>
                            <option value="80">80%</option>
                            <option value="70">70%</option>
                            <option value="60">60%</option>
                            <option value="50">50%</option>
                            <option value="40">40%</option>
                            <option value="30">30%</option>
                            <option value="20">20%</option>
                            <option value="10">10%</option>
                            <option value="0">0%</option>
                        </select>
                        </div>
                    </div>

                    {/* Row with extra wait time */}
                    <div className="flex items-center space-x-4">
                        <label className="text-gray-300 font-medium">Wait for:</label>
                        <div className="flex items-center space-x-4">
                          <input id="appointment-time" type="time" name="extra_wait" onChange={handleChange} value={time_to_input(settings.extra_wait)} step="1" className="bg-gray-700 text-white p-1 rounded-md" />
                        </div>
                    </div>
                </div>
              </div>
              
              {/* Tooltip */}
              {shouldShowTooltip && (
                <Tooltip
                  id={`tooltip-${action.index}`}
                  place="right"
                  className="z-50"
                  style={{ backgroundColor: 'transparent', padding: 0, border: 'none' }}
                >
                  <ResourceTooltip 
                    beforeState={action.stateBefore} 
                    afterState={action.stateAfter} 
                  />
                </Tooltip>
              )}
              
              {/* Action Control Buttons */}
              {action.editable && (
                <div className="flex items-center space-x-1">
                  {/* Move Up Button */}
                  {action.index !== 0 && (
                    <button
                      onClick={() => onMoveAction(action.planetId, action.index, 'up')}
                      className="bg-gray-600 hover:bg-gray-500 text-white px-2 rounded text-xs"
                      disabled={action.index === 0} // Disable if it's the first item
                    >
                      ▲
                    </button>
                  )}

                  {/* Move Down Button */}
                  { !last && (
                    <button
                      onClick={() => onMoveAction(action.planetId, action.index, 'down')}
                      className="bg-gray-600 hover:bg-gray-500 text-white px-2 rounded text-xs"
                      disabled={last} // Disable if it's the last item
                    >
                      ▼
                    </button>
                  )}
                  

                  {/* Toggle Deactivate Button */}
                  <button
                    onClick={() => onToggleDeactivate(action.planetId, action.index)}
                    className={(isDeactivated ? "bg-green-600 hover:bg-green-700" : "bg-yellow-600 hover:bg-yellow-700") + " text-white px-2 rounded text-xs"}
                    title={isDeactivated ? "Activate" : "Deactivate"}
                  >
                    {isDeactivated ? "✓" : "⏸"}
                  </button>

                  {/* Delete Button */}
                  <button
                    onClick={() => onDeleteAction(action.planetId, action.index)}
                    className="bg-red-600 hover:bg-red-700 text-white px-2 rounded text-xs"
                  >
                    X
                  </button>
                </div>
              )}
              
            </li>
    );
}